import * as BABYLON from '@babylonjs/core'
import { DisposerBag } from './disposerBag'

/** `[stop, cssColor]` pairs for `CanvasGradient.addColorStop` — 0 is the top of the sky, 1 the horizon. */
export type GradientStop = [number, string]

/**
 * A big inward-facing sphere painted with a vertical gradient sky, lit from
 * inside via an emissive texture (no real lighting contribution). The cheap
 * "dusk plaza" / "alpine daylight" backdrop trick reused across every
 * walkable exterior scene so far (PresentRealistic's dusk dome, Mountain
 * Lot's daylight dome) — same `DynamicTexture` gradient, same sphere setup.
 */
export function buildGradientSkyDome(
  scene: BABYLON.Scene,
  bag: DisposerBag,
  stops: GradientStop[],
  opts: { diameter?: number; textureHeight?: number } = {},
): BABYLON.Mesh {
  const { diameter = 600, textureHeight = 512 } = opts

  const tex = bag.track(new BABYLON.DynamicTexture('skyGrad', { width: 8, height: textureHeight }, scene, false))
  const ctx = tex.getContext() as unknown as CanvasRenderingContext2D
  const grad = ctx.createLinearGradient(0, 0, 0, textureHeight)
  stops.forEach(([stop, color]) => grad.addColorStop(stop, color))
  ctx.fillStyle = grad
  ctx.fillRect(0, 0, 8, textureHeight)
  tex.update(false)

  const mat = bag.track(new BABYLON.StandardMaterial('skyGradMat', scene))
  mat.emissiveTexture = tex
  mat.diffuseColor = BABYLON.Color3.Black()
  mat.specularColor = BABYLON.Color3.Black()
  mat.backFaceCulling = false
  mat.disableLighting = true

  const dome = bag.track(BABYLON.MeshBuilder.CreateSphere('skyDome', { diameter, segments: 10 }, scene))
  dome.material = mat
  dome.infiniteDistance = true
  dome.isPickable = false
  dome.applyFog = false
  return dome
}
